export type ActivityStatusPhase =
  | 'pending'
  | 'active'
  | 'completed'
  | 'warning'
  | 'failed'
  | 'canceled';

export type ActivityStatusPresentation = {
  leadingVisual: 'hidden' | 'visible';
  text: 'shimmer' | 'static';
};

export function resolveToolActivityStatusPhase({
  isPending,
  hasError,
}: {
  isPending: boolean;
  hasError: boolean;
}): ActivityStatusPhase {
  if (isPending) return 'active';
  return hasError ? 'failed' : 'completed';
}

export function resolveActivityStatusPresentation(
  phase: ActivityStatusPhase
): ActivityStatusPresentation {
  if (phase === 'pending' || phase === 'active') {
    return {
      leadingVisual: 'hidden',
      text: 'shimmer',
    };
  }

  return {
    leadingVisual: 'visible',
    text: 'static',
  };
}
